/* eslint-disable */
import React, { useEffect } from "react";
import { devWarn } from "../utils/dev-logger";
import { SCREENS_WITHOUT_ASTERISK, FIELD_TYPES } from "../utils/constants";
import Bar from "./bar";
import BorderedPanel from "./bordered-panel";
import CallToActionButton from "./call-to-action-button";
import Chips from "./chips";
import PersonThumbnail from "./person-thumbnail";
import FormTextLabel from "./form-text-label";
import FormTextField from "./form-text-field";
import ModernizedTextField from "./modernized/modernized-text-field";
import Text from "./text";
import Icon from "./icon";
import Image from "./image";
import PhotoPicker from "./photo-picker";
import FormImage from "./form-image";
import fieldPropTypes from "./field-prop-types";
import ListItem from "../theme/default/list-item";
import FormCheckboxContainer from "./form-checkbox-container";
import CellWithCheck from "./cell-with-check";
import CellWithCheckMultiple from "./cell-with-check-multiple";
import MapViewField from "./map-view-field";
import List from "./list";
import SegmentControlField from "./segment-control-field";
import Slider from "./slider";
import HtmlTextField from "./html-text-field";
import CellWithSwitch from "./cell-with-switch";
import ExpansionPanel from "./expansion-panel-field";
import FormDateTimePicker from "./form-date-time-picker";
import FormCalendarPicker from "./form-calendar-picker";
import DateTimePicker from "./date-time-picker";
import MessageHeaderView from "./message-header-view";
import MessageDetailsView from "./message-details-view";
import Button from "./button";
import CellWithSubtitle from "./cell-with-subtitle";
import TreatmentCell from "./treatment-cell";
import FormBullet from "./form-bullet";
import FormTextView from "./form-text-view";
import FormCalendarPickerSlots from "./form-calendar-picker-slots";
import ExpandoField from "./expando-field";
import Container from "./container";
import ContainerCarousel from "./container-carousel";
import CollapsibleContainer from "./collapsible-container";
import RadioButtons from "./radio";
import PayPalButton from "./paypal-button";
import ListItemWrapperHOC from "./list-item-wrapper-hoc";
import { getAdjustedToCignaField } from "../utils/cigna-date-time-picker-helper";
import Divider from "./divider";
import FormRadioGroup from "./form-radio-group";
import TimePicker from "./time-picker";
import WebImage from "./web-image";
import Graph from "./graph";
import Title from "../theme/default/title";
import WebViewField from "./web-view-field";
import StepList from "./step-list";
import Inbox from "./inbox";
import AudioField from "./audio";
import VideoField from "./video";
import ModernizedButton from "./modernized-button";
import ModernizedInlineMessage from "./modernized/modernized-inline-message";
import ModernizedToggle from "./modernized/modernized-toggle";
import ModernizedRangeSlider from "./modernizedRangeSlider";
import ModernizedAccordion from "./modernized/modernized-accordion";
import { isModernizedTextField } from "../utils/is-modernized-text-field";
import ModernizedPhoneNumber from "./modernized/modernized-phone-number";
import IncrementerButton from "./incrementer-button";
import ModernizedIconButton from "./modernized/modernized-icon-button";

const fields = {
  callToActionButton: CallToActionButton,
  personThumbnail: PersonThumbnail,
  borderedPanel: BorderedPanel,
  bar: Bar,
  formTextField: FormTextField,
  modernizedTextField: ModernizedTextField,
  text: Text,
  webImage: WebImage,
  icon: Icon,
  image: Image,
  photoPicker: PhotoPicker,
  formImage: FormImage,
  formTextLabel: FormTextLabel,
  listItemWrapper: ListItemWrapperHOC,
  listItem: ListItem,
  mapViewField: MapViewField,
  formCheckboxContainer: FormCheckboxContainer,
  formRadioGroup: FormRadioGroup,
  settingsButton: CallToActionButton,
  cellWithCheck: CellWithCheck,
  cellWithCheckMultiple: CellWithCheckMultiple,
  treatmentCell: TreatmentCell,
  list: List,
  segmentControlField: SegmentControlField,
  slider: Slider,
  stepList: StepList,
  htmlTextField: HtmlTextField,
  cellWithSwitch: CellWithSwitch,
  cellWithSubtitle: CellWithSubtitle,
  formDateTimePicker: FormDateTimePicker,
  dateTimePicker: DateTimePicker,
  formCalendarPicker: FormCalendarPicker,
  messageHeaderView: MessageHeaderView,
  messageDetailsView: MessageDetailsView,
  button: Button,
  formBullet: FormBullet,
  formTextView: FormTextView,
  formCalendarPickerSlots: FormCalendarPickerSlots,
  expandoField: ExpandoField,
  container: Container,
  containerCarousel: ContainerCarousel,
  collapsibleContainer: CollapsibleContainer,
  formRadioButtons: RadioButtons,
  paypalButton: PayPalButton,
  divider: Divider,
  webViewField: WebViewField,
  suggestionChips: Chips,
  inbox: Inbox,
  containerSpacer: Container,
  barGraph: Graph,
  timePicker: TimePicker,
  incrementerButton: IncrementerButton,
  modernizedButton: ModernizedButton,
  audio: AudioField,
  video: VideoField,
  inlineMessage: ModernizedInlineMessage,
  modernizedToggle: ModernizedToggle,
  modernizedRangeSlider: ModernizedRangeSlider,
  accordion: ModernizedAccordion,
  modernizedPhoneNumber: ModernizedPhoneNumber,
  modernizedIconButton: ModernizedIconButton,
  expansionPanel: ExpansionPanel
};

// Fields of type not mentioned in the following array will have their names prepended with a double underscore ("__")
// so that they are dropped later.
const formFieldTypes = [
  "divider",
  "borderedPanel",
  "callToActionButton",
  "personThumbnail",
  "bar",
  "formTextField",
  "modernizedTextField",
  "modernizedPhoneNumber",
  "text",
  "image",
  "webImage",
  "photoPicker",
  "formImage",
  "formTextLabel",
  "listItemWrapper",
  "listItem",
  "mapViewField",
  "formCheckboxContainer",
  "formRadioGroup",
  "settingsButton",
  "stepList",
  "cellWithCheck",
  "cellWithCheckMultiple",
  "treatmentCell",
  "slider",
  "htmlTextField",
  "cellWithSwitch",
  "cellWithSubtitle",
  "formDateTimePicker",
  "dateTimePicker",
  "formCalendarPicker",
  "messageHeaderView",
  "messageDetailsView",
  "button",
  "formTextView",
  "formCalendarPickerSlots",
  "expandoField",
  "container",
  "formRadioButtons",
  "paypalButton",
  "suggestionChips",
  "barGraph",
  "timePicker",
  "containerSpacer",
  "containerCarousel",
  "collapsibleContainer",
  "incrementerButton",
  "audio",
  "video",
  "modernizedButton",
  "inlineMessage",
  "modernizedToggle",
  "modernizedRangeSlider",
  "accordion",
  "modernizedIconButton"
];

const buildLink = (link, label, onClick, handleKeyDown, targetBlank) => (
  <a
    className='link-web-sdk'
    onClick={onClick}
    onKeyDown={handleKeyDown}
    href={link}
    target={targetBlank ? "_blank" : "_self"}
    rel={targetBlank && "noreferrer noopener"}
  >
    {label}
  </a>
);

const buildFieldAction = (field, appData, components) => {
  const { links, type: fieldType, title } = field;
  // removing next line brings account settings => Authorized consenters screen crush
  // eslint-disable-next-line no-shadow
  const { Text } = components;
  const { handleButtonClick } = appData;

  const link = links[0];
  const pathComponents = link.url.split("/");
  const actionPosition = pathComponents.indexOf("action");
  const query =
    link.url.indexOf("?") >= 0 ? link.url.slice(link.url.indexOf("?") + 1) : "";
  const type = actionPosition >= 0 && pathComponents[actionPosition + 1];
  let value = actionPosition >= 0 && pathComponents[actionPosition + 2];
  pathComponents[pathComponents.length - 1] = pathComponents[
    pathComponents.length - 1
  ].slice(0, pathComponents[pathComponents.length - 1].indexOf("?"));

  if (fieldType === "text" && links.length > 0) {
    const paragraphsList = title.split("\n\n");

    const preparedParagraphs = paragraphsList.map(paragraphsPart => {
      let paragraphs = paragraphsPart.split("\n");

      if (paragraphs.length > 0) {
        paragraphs = paragraphs.map(paragraph => [paragraph]);
      }

      links.forEach(linkItem => {
        paragraphs = paragraphs.map(parts => {
          return parts.reduce((partsList, part) => {
            if (typeof part !== "string") {
              partsList.push(part);
              return partsList;
            }

            const { string } = linkItem;

            if (part.includes(string) && string) {
              const [stringStart, stringEnd] = part.split(string);

              partsList.push(stringStart);

              if (linkItem.webLink) {
                partsList.push(
                  buildLink(
                    linkItem.webLink,
                    string,
                    _,
                    _,
                    !!linkItem.target_blank
                  )
                );
              } else if (linkItem.url.includes("http://teladoc/action/")) {
                const [path, queryString = ""] = linkItem.url.split("?");

                const pathComponentsArray = path.split("/");
                const actionPositionIndex =
                  pathComponentsArray.indexOf("action");
                const actionType =
                  actionPositionIndex >= 0 &&
                  pathComponentsArray[actionPositionIndex + 1];
                const actionValue =
                  actionPositionIndex >= 0 &&
                  pathComponentsArray[actionPositionIndex + 2];

                const params = queryString
                  .split("&")
                  .reduce((paramsList, param) => {
                    if (param) {
                      const [key, paramValue] = param.split("=");
                      return Object.assign(paramsList, {
                        [key]: decodeURIComponent(
                          paramValue.replace(/\+/g, " ")
                        )
                      });
                    } else {
                      return paramsList;
                    }
                  }, {});

                if (actionType === "call") {
                  partsList.push(buildLink(`tel:${actionValue}`, string));
                } else {
                  const handleClick = e => {
                    e.preventDefault();
                    handleButtonClick(field.name, field.text, {
                      type: actionType,
                      value: pathComponentsArray
                        .slice(actionPositionIndex + 2)
                        .join("/"),
                      data: params
                    });
                  };

                  partsList.push(buildLink("#", string, handleClick));
                }
              } else if (linkItem.url.includes("http://bold")) {
                partsList.push(<b>{string}</b>);
              } else if (
                !linkItem.url.includes("http://bold") &&
                linkItem.url.includes("http")
              ) {
                const handleClick = e => {
                  e.preventDefault();
                  handleButtonClick(field.name, field.text, {
                    type: "webview",
                    value: linkItem.url,
                    webLink: linkItem.webLink,
                    target_blank: !!linkItem.target_blank
                  });
                };

                const handleKeyDown = e => {
                  if (e.key === " " || e.key === "Enter") {
                    handleClick(e);
                  }
                };

                partsList.push(
                  buildLink("#", string, handleClick, handleKeyDown)
                );
              }
              partsList.push(stringEnd);
            } else {
              partsList.push(part);
            }

            return partsList;
          }, []);
        }, []);
      });
      return paragraphs;
    });

    return {
      type: "bold",
      value: preparedParagraphs.map(paragraphs => (
        <p key={paragraphs} className='text-web-sdk'>
          {paragraphs.map((paragraph, index) => (
            <Text key={paragraph} name={`${field.name}-${index}`} isSpan>
              {paragraph}
            </Text>
          ))}
        </p>
      ))
    };
  } else if (
    link.url.includes("http://teladoc/action/") &&
    pathComponents.length - actionPosition > 2
  ) {
    const data = {};
    if (type === "url" || type === "alert_url") {
      value = pathComponents.slice(actionPosition + 2).join("/");
      if (query.length) {
        const queryParts = query.split("&");
        queryParts.forEach(queryPart => {
          data[decodeURIComponent(queryPart.slice(0, queryPart.indexOf("=")))] =
            decodeURIComponent(queryPart.slice(queryPart.indexOf("=") + 1));
        });
      }
    }
    return {
      type,
      value,
      data
    };
  } else if (link.url.includes("http") && !link.url.includes("http://bold")) {
    return {
      type: "webview",
      value: link.url
    };
  }
};

const formatFieldName = ({ type, name }) => {
  let formattedFieldName = name;

  if (!formFieldTypes.includes(type) && !name.startsWith("__")) {
    formattedFieldName = `__${name}`;
  }
  if (name?.match(/^memberButton_/)) {
    formattedFieldName = "member_id";
  }
  return formattedFieldName;
};

const FieldBuilder = ({
  field,
  lastOfKind,
  onlyOfKind,
  appData,
  components,
  screen
}) => {
  const isIgnoredField =
    field.params && field.params.split("|").includes("TDFieldOptionIgnore");

  useEffect(() => {
    if (
      (field.type === "formTextField" || isModernizedTextField(field)) &&
      field.text &&
      !isIgnoredField
    ) {
      appData.handleChange({ [field.name]: field.text });
    }
  }, []);

  if (field.type === "raw") {
    return field.el;
  }

  const Field = fields[field.type];

  if (!Field) {
    devWarn("Unknown field found. Omitting", field);
    return null;
  }
  if (isIgnoredField) {
    return null;
  }
  if (field.links && field.links.length) {
    field.action = buildFieldAction(field, appData, components);
  }

  field = getAdjustedToCignaField(field, appData);

  if (
    appData.screensHistoryFlow.slice(-1)[0] &&
    !appData.screensHistoryFlow
      .slice(-1)[0]
      .name.toLowerCase()
      .includes("filter") &&
    ((appData.screensHistoryFlow.slice(-1)[0].params || "").includes(
      "TDScreenOptionHideAsterisks"
    ) ||
      (appData.screensHistoryFlow.slice(-1)[0].name !==
        "ConsultationDermIntake" &&
        !SCREENS_WITHOUT_ASTERISK.includes(screen?.name)))
  ) {
    appData.showAsterisk = true;
  } else {
    appData.showAsterisk = false;
  }

  switch (field.type) {
    case "formTextField":
      if (field.options?.length) {
        return (
          <Field
            field={field}
            appData={appData}
            components={components}
            value={appData.values[field.name]}
            onChange={v => appData.handleChange({ [field.name]: v })}
            screen={screen}
          />
        );
      } else {
        const theField = { ...field };
        if (appData.values.hasOwnProperty(field.name)) {
          theField.text = appData.values[field.name];
        }
        return (
          <Field
            field={theField}
            appData={appData}
            components={components}
            screen={screen}
          />
        );
      }
    case FIELD_TYPES.modernizedTextField:
      if (field.options?.length) {
        return (
          <Field
            field={field}
            appData={appData}
            components={components}
            value={appData.values[field.name]}
            onChange={v => appData.handleChange({ [field.name]: v })}
          />
        );
      } else {
        const theField = { ...field };
        if (appData.values.hasOwnProperty(field.name)) {
          theField.text = appData.values[field.name];
        }
        return (
          <Field field={theField} appData={appData} components={components} />
        );
      }
    default:
      if (
        field.name === "CareOptionTitle" ||
        field.name === "AllCareOptionsTitle"
      ) {
        return <Title title={field.title} name={field.name} />;
      }
      field.name = formatFieldName(field);

      return (
        <Field
          field={field}
          lastOfKind={lastOfKind}
          onlyOfKind={onlyOfKind}
          appData={appData}
          components={components}
          screen={screen}
          ariaLabel={field.accessibility ? field.accessibility.label : null}
        />
      );
  }
};

FieldBuilder.propTypes = fieldPropTypes;

export default FieldBuilder;
